import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

/**
 * Runtime flag: active = BleDeviceManagerFacade routes BLE to the mock, inactive = to the real
 * manager. Flipped by activate/deactivateMockHuntingDevice.
 */
@Injectable()
export class MockHuntingDeviceGate {
  private readonly activeSubject$ = new BehaviorSubject<boolean>(false);
  public readonly active$ = this.activeSubject$.pipe(distinctUntilChanged());

  public activate(): void {
    this.activeSubject$.next(true);
  }

  public deactivate(): void {
    this.activeSubject$.next(false);
  }

  public get isActive(): boolean {
    return this.activeSubject$.value;
  }
}
